'use client';

import React, { useEffect, useState } from 'react';
import './Accordion.css';
import { MdArrowForwardIos } from 'react-icons/md';

export default function Accordion({
  title,
  content,
  children,
  theme = 'fill',
  innerPadding = true,
  signal,
}: {
  title: string | React.ReactNode;
  content?: string;
  children?: React.ReactNode;
  theme?: 'fill' | 'outline' | 'black' | 'yellow';
  innerPadding?: boolean;
  signal?: boolean;
}) {
  const [active, setActive] = useState(false);

  useEffect(()=>{
    if (typeof signal !== 'undefined') {
      setActive(false);
    }
  }, [signal]);

  const handleToggle = () => {
    setActive(!active);
  };

  let buttonClasses = '';
  let containerClasses = '';
  const padding = innerPadding ? 'p-4' : '';

  switch (theme) {
    case 'fill':
      buttonClasses = 'bg-accent font-bold';
      containerClasses = 'border border-accent';
      break;
    case 'black':
      buttonClasses = 'bg-black font-bold text-white';
      containerClasses = 'border border-black';
      break;
    case 'outline':
      buttonClasses = 'pl-0 font-bold';
      containerClasses = 'border-b border-accent';
      break;
    case 'yellow':
      buttonClasses = 'bg-brand';
      containerClasses = 'border-b border-t text-black border-black';
      break;
    default:
      break;
  }

  return (
    <div className={`accordion-panel ${containerClasses}`}>
      <button
        onClick={() => handleToggle()}
        aria-expanded={active}
        className={`${buttonClasses} ${padding} accordion-trigger block w-full py-2 pr-10 text-left`}
      >
        {title}
        <span className='accordion-state'>
          <MdArrowForwardIos />
        </span>
      </button>
      <div className='accordion-content' aria-hidden={!active}>
        <div>
          {typeof content === 'string' ? (
            <div
              className='prose p-4'
              dangerouslySetInnerHTML={{ __html: String(content) }}
            />
          ) : (
            <div className={`${padding}`}>{children}</div>
          )}
        </div>
      </div>
    </div>
  );
}
